/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Form, Modal, Select, Typography, Button, message, notification, Row, Col } from 'antd';
import SPUploadSingleFile from '../../../base/SPUploadSingleFile';
import emiter, {
	EVENT_VEHICLE_BATCH_UPLOAD,
	EVENT_VEHICLE_RESEARCH,
	EVENT_VEHICLE_SEARCH_LIST,
} from '../../../../events';
import request from '../../../../request';
import { API_VEHICLE_BATCH_ADD, API_VEHICLE_GET_STORE, API_UPLOAD_ZIP_BY_TYPE } from '../../../../hooks/carRental/_';
const { Text } = Typography;

interface PropsType {
	enums?: any;
}

const UploadModal: React.FC<PropsType> = props => {
	const mainFormFields = {
		guishumendian: {
			name: 'store_code',
			label: '归属门店',
			required: true,
			message: '请选择归属门店',
			placeholder: '请选择',
		},
		xingshizhengyasuobao: {
			name: 'driving_license',
			label: '',
			required: false,
			message: '请上传行驶证压缩包',
		},
		shangyexianyasuobao: {
			name: 'commercial_insurance',
			label: '',
			required: false,
			message: '请上传商业险压缩包',
		},
		jiaoqiangxianyasuobao: {
			name: 'traffic_insurance',
			label: '',
			required: false,
			message: '请上传交强险压缩包',
		},
	};

	const [form] = Form.useForm();
	const [modalVisible, setModalVisible] = useState(false);
	const [storeList, setStoreList] = useState([]);

	// 关闭弹窗
	const closeModal = () => {
		form.resetFields();
		setModalVisible(false);
	};

	// 打开弹窗
	const openModal = () => {
		setModalVisible(true);
	};

	// 下载模版文件
	const downloadTemp = (url: string, name: string) => {
		// 下载链接
		const downloadUrl = url;
		// 创建一个a标签
		const link = document.createElement('a');
		link.href = downloadUrl;
		link.download = name; // 设置下载后保存的文件名
		// 将a标签添加到页面中
		document.body.appendChild(link);
		// 触发点击事件以开始下载
		link.click();
		// 下载完成后移除a标签
		document.body.removeChild(link);
	};

	// 确认导入
	const importFile = () => {
		form.validateFields().then((fieldsVale: any) => {
			if (!fieldsVale.driving_license && !fieldsVale.commercial_insurance && !fieldsVale.traffic_insurance) {
				message.error('三个压缩包至少需要有一个上传');
				return;
			}

			request({
				url: API_VEHICLE_BATCH_ADD,
				timeout: 300000,
				method: 'POST',
				data: {
					store_code: fieldsVale.store_code,
					veh_detail: {
						driving_license:
							(fieldsVale.driving_license && fieldsVale.driving_license['行驶证']) || undefined,
						traffic_insurance:
							(fieldsVale.traffic_insurance && fieldsVale.traffic_insurance['交强险']) || undefined,
						commercial_insurance:
							(fieldsVale.commercial_insurance && fieldsVale.commercial_insurance['商业险']) || undefined,
					},
				},
			})
				.then((res: any) => {
					// 关闭抽屉并查询列表
					if (res.errno === 0) {
						// 提示正在识别
						notification.open({
							message: '批量上传提示',
							// description: '车辆正在识别上传中，请耐心等待～上传任务成功后将通过消息中心通知您，请勿重复上传',
							description: <><div>车辆正在识别上传中，请耐心等待～</div><div>上传任务成功后将通过消息中心通知您，请勿重复上传</div></>
						});
						// notification.open({
						// 	duration: res?.data?.failed === 0 ? 4.5 : null,
						// 	message: '批量上传提示',
						// 	description: (
						// 		<>
						// 			<div>请及时完善成功车辆的其他必填信息！以免影响车辆使用</div>
						// 			<div>{`共识别到${res.data.total}个车牌号，已成功${
						// 				res.data.total - res.data.failed
						// 			}个，失败${res.data.failed}个`}</div>
						// 		</>
						// 	),
						// 	btn:
						// 		res?.data?.failed === 0 ? null : (
						// 			<Button
						// 				type="primary"
						// 				size="small"
						// 				disabled={res.data.failed === 0}
						// 				onClick={() => downloadTemp(res.data.download, '失败原因.xlsx')}
						// 			>
						// 				点击下载失败原因
						// 			</Button>
						// 		),
						// });
						closeModal();
						// 关闭弹窗，查询列表
						emiter.emit(EVENT_VEHICLE_RESEARCH);
					} else {
						message.error(res.errmsg || '车辆批量上传失败');
					}
				})
				.catch(err => {
					message.error(err.message || '车辆批量上传失败');
				});
		});
	};

	const getStoreList = () => {
		request({
			url: API_VEHICLE_GET_STORE,
			method: 'GET',
		}).then((res: any) => {
			setStoreList(res.data);
		});
	};

	useEffect(() => {
		getStoreList();
		emiter.on(EVENT_VEHICLE_BATCH_UPLOAD, openModal);
		return () => {
			emiter.removeAllListeners(EVENT_VEHICLE_BATCH_UPLOAD);
		};
	}, []);

	return (
		<Modal
			title="批量上传车辆"
			centered
			width="70%"
			open={modalVisible}
			onCancel={closeModal}
			onOk={importFile}
			okText="确认创建"
		>
			<div style={{ marginLeft: '20px', marginBottom: '20px', fontSize: '12px' }}>
				<div>注：</div>
				<div>1、请将行驶证、商业险、交强险分别上传至各自文件夹中（至少上传一个），请勿混传、重复上传</div>
				<div>2、仅支持上传压缩包，压缩包大小不超过150M，文件大小不超过2M</div>
			</div>
			<Form form={form}>
				<Form.Item
					name={mainFormFields.guishumendian.name}
					label={mainFormFields.guishumendian.label}
					rules={[
						{
							required: mainFormFields.guishumendian.required,
							message: mainFormFields.guishumendian.message,
						},
					]}
					labelCol={{ span: 2 }}
				>
					<Select
						placeholder={mainFormFields.guishumendian.placeholder}
						showSearch
						optionFilterProp="children"
					>
						{storeList &&
							storeList.map((item: any) => (
								<Select.Option value={item.store_code} key={item.store_code}>
									{item.store_name}
								</Select.Option>
							))}
					</Select>
				</Form.Item>
				<Row gutter={24}>
					<Col span={8}>
						<div style={{ marginLeft: '20px' }}>
							<Text>行驶证压缩包</Text>
							<Form.Item
								name={mainFormFields.xingshizhengyasuobao.name}
								label={mainFormFields.xingshizhengyasuobao.label}
								rules={[
									{
										required: mainFormFields.xingshizhengyasuobao.required,
										message: mainFormFields.xingshizhengyasuobao.message,
									},
								]}
							>
								<SPUploadSingleFile
									action={`${API_UPLOAD_ZIP_BY_TYPE}1`}
									name={mainFormFields.xingshizhengyasuobao.name}
									fileType="zip"
									fileSize={150}
								/>
							</Form.Item>
						</div>
					</Col>
					<Col span={8}>
						<div style={{ marginLeft: '20px' }}>
							<Text>商业险压缩包</Text>
							<Form.Item
								name={mainFormFields.shangyexianyasuobao.name}
								label={mainFormFields.shangyexianyasuobao.label}
								rules={[
									{
										required: mainFormFields.shangyexianyasuobao.required,
										message: mainFormFields.shangyexianyasuobao.message,
									},
								]}
							>
								<SPUploadSingleFile
									action={`${API_UPLOAD_ZIP_BY_TYPE}3`}
									name={mainFormFields.shangyexianyasuobao.name}
									fileType="zip"
									fileSize={150}
								/>
							</Form.Item>
						</div>
					</Col>
					<Col span={8}>
						<div style={{ marginLeft: '20px' }}>
							<Text>交强险压缩包</Text>
							<Form.Item
								name={mainFormFields.jiaoqiangxianyasuobao.name}
								label={mainFormFields.jiaoqiangxianyasuobao.label}
								rules={[
									{
										required: mainFormFields.jiaoqiangxianyasuobao.required,
										message: mainFormFields.jiaoqiangxianyasuobao.message,
									},
								]}
							>
								<SPUploadSingleFile
									action={`${API_UPLOAD_ZIP_BY_TYPE}2`}
									name={mainFormFields.jiaoqiangxianyasuobao.name}
									fileType="zip"
									fileSize={150}
								/>
							</Form.Item>
						</div>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default UploadModal;
